<ng-container *ngIf="isLoading">
  <app-loading-spinner></app-loading-spinner>
</ng-container>
<div id="page-container" *ngIf="!isLoading">
  <!-- Page Content -->
  <div class="content content-narrow">
    <!-- Dynamic Table Full -->
    <div class="block">
      <div class="page o-center-page__page">
        <header class="c-header-language">
          <div class="container-fixed">
            <div class="c-header-language__container">
              <div class="c-header-language__logo"></div>
            </div>
          </div>
        </header>
        <main class="o-center-page__main">
          <div
            class="login-container-custom mb-3 card p-4 justify-content-center">
            <div class="mt-4 c-texto__contenido">
              <p>Bienvenido(a) a:</p>
            </div>
            <div class="m-auto">
              <img
                class="lazy"
                src="../../../assets/img/backgrounds/sifca-logo-05-opt.webp"
                alt="Logo SIFCA" />

              <div class="c-texto__contenido mx-2 text-center mb-5 mt-4">
                <p style="border-top: 1px solid" class="p-1">
                  Este es un espacio para ti, aquí puedes iniciar sesión.
                </p>
                <p>
                  <a
                    class="btn btn-login btn-pequeno u-margin-auto"
                    (click)="login()"
                    title="Iniciar sesión"
                    ><span>INICIAR SESI&Oacute;N</span></a
                  >
                </p>
              </div>
            </div>
          </div>
        </main>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
  <!-- END Page Content -->
</div>
